const SemesterEnum = Object.freeze([{
    name: "1st Semester",
    code: "FISES",
}, {
    name: "2nd Semester",
    code: "SESES",
}, {
    name: "Year Baased",
    code: "YeBased",
}]);

export default SemesterEnum;